import { render, staticRenderFns } from "./BindsCardMediaCover.vue?vue&type=template&id=7ad67876&"
import script from "./BindsCardMediaCover.vue?vue&type=script&lang=js&"
export * from "./BindsCardMediaCover.vue?vue&type=script&lang=js&"
import style0 from "./BindsCardMediaCover.vue?vue&type=style&index=0&id=7ad67876&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports